import { Button, Stack, Typography } from '@mui/material';
import { Connector } from '@domain/connection/models/Connector';
import { Paper } from '@shared/ui';
import ConnectionActiveImports from '@features/connections/generic/components/ConnectionActiveImports';
import ConnectionSetupHeader from './ConnectionSetupHeader';
import SetupSection from './SetupSection';
import SetupFrame from './SetupFrame';

interface ImportProgressProps {
  connector: Connector;
  connectionId: string;
  title: string;
  description: string;
  onContinue: () => void;
  continueDisabled?: boolean;
}

const ImportProgress = ({
  connector,
  connectionId,
  title,
  description,
  onContinue,
  continueDisabled = false,
}: ImportProgressProps) => (
  <SetupFrame connector={connector} steps={[{ id: 'import', label: 'Import' }]} step="import" busy={false} primaryLabel="Finish" primaryDisabled={continueDisabled} onPrimary={onContinue} error={null}>
    <SetupSection
      title={title}
      description={description}
    >
      <Paper>
        <ConnectionActiveImports connectionId={connectionId} />
      </Paper>
    </SetupSection>
  </SetupFrame>
);

export default ImportProgress;
